// extracted by mini-css-extract-plugin
export default {"verificarEmailContainer":"VerificarEmail_verificarEmailContainer__+NDTs"};